import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import { AverageCalls, DashboardSearchProps, ReasonForCalls } from "../../../../domain/repositories/dashboard.repository";
import DateDto from "../../../dto/date.dto";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ReasonForCallDto from "../../../dto/reason_for_call.dto";

const getReasonsForCallApiImpl = async (_: DashboardSearchProps): Promise<Either<ErrorEntity, ReasonForCalls[]>> => {
    //TODO : add operationId, humanAgentId, aiAgentId, callTypeId to the request
    try {
        let relativeUrl = "/stats/reason-detail?";
        const { startDate, endDate, aiAgentId, callTypeId, humanAgentId, operationId }: { startDate: Date, endDate: Date, operationId?: string, humanAgentId?: string, aiAgentId?: string, callTypeId?: string, } = _;
        if(startDate) relativeUrl += `start_date=${DateDto.toServer(startDate)}&`
        if(endDate) relativeUrl += `end_date=${DateDto.toServer(endDate)}&`
        if(aiAgentId) relativeUrl += `agent_id=${aiAgentId}&`
        if(callTypeId) relativeUrl += `call_type=${callTypeId}&`
        if(humanAgentId) relativeUrl += `human_agent_id=${humanAgentId}&`
        if(operationId) relativeUrl += `operation_id=${operationId}&`
        relativeUrl = relativeUrl.slice(0, -1);
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl, {
            contentType: 'application/json',
        });
        const parsed = response.map((item: any) => ReasonForCallDto.fromJSON(item));
        return right(parsed);

    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default getReasonsForCallApiImpl;